var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"instrument-alteration"}},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('el-button',{staticStyle:{"width":"150px"},on:{"click":_vm.openEditDialog}},[_vm._v("选择商品")])],1),_vm._v(" "),_c('account',{attrs:{"type":"编辑商品","product":_vm.product}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fb612b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/instrument/Alteration.vue
// module id = null
// module chunks = 